// extracted by mini-css-extract-plugin
export default {"help-button":"AppTitle_help-button__4tl1+","app-title":"AppTitle_app-title__hie8C","scs-header":"AppTitle_scs-header__8p7kh"};